import {
  EGlobalSearchItemType,
  EGlobalSearchTargetKind,
} from "../types/global-search";
import { ENavigationIcon } from "../types/navigation-icon";

// NOTE: NSAI-6812 — the navigation icon of every destination that has a
// sidebar entry. A palette PAGE / SETTINGS_* result resolves its icon through
// its target, so a page and each of its tabs ("My files", "Shared with me")
// wear the sidebar entry's icon. A destination missing here has no sidebar
// entry and keeps its result type's generic icon.
export const GLOBAL_SEARCH_TARGET_NAVIGATION_ICONS: Readonly<
  Partial<Record<EGlobalSearchTargetKind, ENavigationIcon>>
> = {
  [EGlobalSearchTargetKind.NEW_CHAT]: ENavigationIcon.NEW_CHAT,
  [EGlobalSearchTargetKind.CALL_ASSISTANT]: ENavigationIcon.CALL_ASSISTANT,
  [EGlobalSearchTargetKind.UPLOADS]: ENavigationIcon.UPLOADS,
  [EGlobalSearchTargetKind.ASSISTANTS]: ENavigationIcon.ASSISTANTS,
  [EGlobalSearchTargetKind.KNOWLEDGE]: ENavigationIcon.KNOWLEDGE,
  [EGlobalSearchTargetKind.DOC_RECOGNITION]: ENavigationIcon.DOC_RECOGNITION,
  [EGlobalSearchTargetKind.SKILLS]: ENavigationIcon.SKILLS,
  [EGlobalSearchTargetKind.SKILL_CATALOG]: ENavigationIcon.SKILLS,
  [EGlobalSearchTargetKind.GENERATED_FILES]: ENavigationIcon.GENERATED_FILES,
  [EGlobalSearchTargetKind.AGENTS]: ENavigationIcon.AGENTS,
  [EGlobalSearchTargetKind.ANONYMIZATION_LAB]:
    ENavigationIcon.ANONYMIZATION_LAB,
  [EGlobalSearchTargetKind.PROMPT_LIBRARY]: ENavigationIcon.PROMPT_LIBRARY,
  [EGlobalSearchTargetKind.MODELS]: ENavigationIcon.MODELS,
  [EGlobalSearchTargetKind.ANALYTICS]: ENavigationIcon.ANALYTICS,
  [EGlobalSearchTargetKind.INTEGRATIONS]: ENavigationIcon.INTEGRATIONS,
};

// NOTE: NSAI-6812 — record types that wear the icon of the sidebar section
// they belong to. Every integration-shaped record lives under Integrations.
export const GLOBAL_SEARCH_ITEM_TYPE_NAVIGATION_ICONS: Readonly<
  Partial<Record<EGlobalSearchItemType, ENavigationIcon>>
> = {
  [EGlobalSearchItemType.INTEGRATION_CONNECTION]: ENavigationIcon.INTEGRATIONS,
  [EGlobalSearchItemType.INTEGRATION_PROVIDER]: ENavigationIcon.INTEGRATIONS,
  [EGlobalSearchItemType.CUSTOM_INTEGRATION]: ENavigationIcon.INTEGRATIONS,
};
